<template>
  <Component :is="viewLayout">
    <template #page-heading>
      <h1 class="heading heading--large">
        Performance Operacional
      </h1>
    </template>

    <template #main>
      <div class="operational-performance">
        <BaseGrid
          columns="1"
          dense
        >
          <BaseErrorState
            v-if="isErrorState"
            icon="top"
            align="center"
            class="operational-performance__error"
          />

          <div
            v-else-if="isLoadingQuickSightDashboard"
            class="operational-performance__loader"
          >
            <BaseLoaderDefault />
          </div>

          <iframe
            :src="quickSightDashboardUrl"
            width="100%"
            height="100%"
            frameborder="0"
            allowfullscreen
            style="height: 240vh; width: 100%; scrolling: no; frameborder: 0"
          />
        </BaseGrid>
      </div>
    </template>
  </Component>
</template>

<script>
import axios from 'axios';
import { layoutMixin } from '@/utils/mixins'
import BaseGrid from '@/components/base/BaseGrid'
import BasePaneCard from '@/components/base/BasePaneCard'
import CommonPageFilter from '@/components/common/CommonPageFilter'
import BaseLoaderDefault from '@/components/base/BaseLoaderDefault'
import BaseErrorState from '@/components/base/BaseErrorState'
import { mapGetters } from "vuex";

export default {
  name: 'OperationalPerformance',

  components: {
    CommonPageFilter,
    BaseGrid,
    BasePaneCard,
    BaseLoaderDefault,
    BaseErrorState,
  },
  computed: {
    ...mapGetters(['quicksightPlatforms']),
    isQuicksightIntegrated () {
      return this.$auth.user().profile === 'platform'
        && this.quicksightPlatforms.includes(this.$auth.user().platform_name);
    },
  },
  mixins: [
    layoutMixin
  ],

  data() {
    return {
      isErrorState: false,
      isLoadingQuickSightDashboard: true,
      quickSightDashboardUrl: '',
    };
  },

  methods: {
    async getQuickSightURL() {
      try {
        const response = await axios.get(
            `${process.env.VUE_APP_ROOT_API}lead/quicksight/v2/dashboard`, {
            headers: {
              Authorization: `Bearer ${this.$auth.token()}`,
            },
          })
        this.quickSightDashboardUrl = this.modifyUrl(response.data);
      } catch (error) {
        console.error('Error fetching QuickSight dashboard:', error);
        this.isErrorState = true;
      } finally {
        setTimeout(() => {
          this.isLoadingQuickSightDashboard = false;
        }, 2000);
      }
    },
    modifyUrl(url) {
      // Modify the URL to include the desired QuickSight embedding options
      const params = new URLSearchParams(url.split('?')[1]);
      params.set('undoRedoDisabled', 'true');
      params.set('resetDisabled', 'true');
      return `${url.split('?')[0]}?${params.toString()}`;
    }
  },

  mounted() {
    this.getQuickSightURL();
  },
}
</script>

<style lang="scss" scoped>
.operational-performance {
  &__error {
    height: 100%;
    margin: 56px;
  }

  &__loader {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 100px;
  }
}
</style>
